var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "drive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-Icons---Isolated",
    transform: "translate(-388.000000, -1514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drive",
    transform: "translate(388.000000, 1514.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#3777E3",
    points: "8.00048064 42 15.9998798 28 48 28 39.9998798 42"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFCF63",
    points: "32.0004806 28 48 28 32.0004806 0 15.9998798 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#11A861",
    points: "0 28 8.00048064 42 24 14 15.9998798 0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveIcon);
export default __webpack_public_path__ + "static/media/drive-icon.d208179209f0022734d45fbdf8e77bcf.svg";
export { ForwardRef as ReactComponent };